import type { IStyle } from 'fela';

import type { TRuleWithTheme } from '@ackee/fela';

import { ButtonSize, ButtonColor } from './Button.properties';

/**
 * This is only secondary button implementation
 */

const sizes: Record<ButtonSize, IStyle> = {
    [ButtonSize.CAROUSEL]: {
        fontSize: '5.25rem',
        lineHeight: '6.125rem',
    },
    [ButtonSize.LARGE]: {
        fontSize: 'clamp(2rem, 2vw + 1rem, 3rem)',
        lineHeight: '3.75rem',
    },
    [ButtonSize.MEDIUM]: {
        fontSize: 'clamp(1.5rem, 2vw + 1rem, 2rem)',
        lineHeight: '2.5rem',
    },
    [ButtonSize.SMALL]: {
        fontSize: '1.25rem',
        lineHeight: '1.5rem',
    },
};
type StyleProps = { size: ButtonSize; color: ButtonColor };

export const button: TRuleWithTheme<StyleProps> = ({ size, color, theme: { fonts, colors, transition } }) => {
    const isCyan = color === ButtonColor.CYAN;

    return {
        ...sizes[size],
        ...fonts.heroNewBold,

        color: isCyan ? colors.cyan : colors.blue,

        textDecoration: 'underline',
        textDecorationColor: colors.blue,

        transition,
        transitionProperty: 'all',

        cursor: 'pointer',

        ':hover': {
            color: color === ButtonColor.BLUE ? colors.fuchsia : 'inherit',
            textDecoration: isCyan ? 'none' : 'underline',
            textDecorationColor: colors.blue,
        },
    };
};
